function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".add_svg__a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "add_svg__a",
  cx: 12,
  cy: 12,
  r: 11
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "add_svg__a",
  d: "M12 6v12M18 12H6"
});

function SvgAdd(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "add.4d509.svg";
export { SvgAdd as ReactComponent };